.root {
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  padding: 8px 10px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
  transition: background 0.16s ease;
  animation: 0.3s cubic-bezier(0.16, 1, 0.3, 1) both;
  /* global(): иначе имя захешируется и анимация не сыграет — см. shared/styles/animations.css */
  animation-name: global(pop-in);
}
.root:hover {
  background: var(--sunk);
}
/*
 * `filter: opacity()`, а НЕ `opacity` — иначе приглушения не будет вовсе.
 *
 * На `.root` висит `pop-in`, а он заканчивается `to { opacity: 1 }` и с `fill-mode: both`
 * оставляет это значение навсегда. В каскаде CSS объявления анимаций стоят ВЫШЕ обычных
 * авторских — значит `opacity: 0.6` здесь просто не применяется. Проверено: вычисленная
 * `opacity` у отключённой карточки была `1`, и во время переключения компании карточки
 * не гасли — от кликабельных их отличал только курсор.
 *
 * `filter` — другое свойство, анимация его не трогает, и оно СКЛАДЫВАЕТСЯ с ней: карточка
 * по-прежнему плавно появляется и при этом приглушена. `!important` тоже перебил бы анимацию,
 * но заодно убил бы `from { opacity: 0 }` — карточка возникала бы рывком.
 */
.root:disabled {
  cursor: not-allowed;
  filter: opacity(0.6);
}
.root:disabled:hover {
  background: transparent;
}

/* Активная строка (prototype/Prototype.dc.html:141): своя вертикаль паддинга, без анимации. */
.active {
  padding: 9px 10px;
  background: var(--accent-soft);
  box-shadow: inset 0 0 0 1px color-mix(in oklch, var(--accent) 30%, transparent);
  cursor: default;
  animation: none;
}
.active:hover {
  background: var(--accent-soft);
}

.text {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
  flex: 1;
}

.name {
  font-size: 13px;
  font-weight: 550;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nameActive {
  font-weight: 600;
}

.domain {
  font-size: 10.5px;
  color: var(--ink-3);
  font-family: 'JetBrains Mono Variable', monospace;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.check {
  color: var(--accent);
  flex-shrink: 0;
}

.chevron {
  color: var(--ink-4);
  flex-shrink: 0;
}
